var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.cashOutData.id && !_vm.request && !_vm.incashment
      ? _c("div", [
          _c("p", [
            _vm._v("Рекомендованная сумма\n      "),
            _c("strong", [
              _vm._v(
                _vm._s(
                  Math.ceil(this.cashOutData.recommended_sum).toLocaleString(
                    "ru-RU"
                  )
                )
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-group" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.sum,
                    expression: "sum",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "number" },
                domProps: { value: _vm.sum },
                on: {
                  change: _vm.checkCashOutSum,
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.sum = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "vue-ladda",
                {
                  attrs: {
                    "button-class": "btn btn-success",
                    "data-style": "zoom-in",
                    loading: _vm.loading,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.makeCashOut()
                    },
                  },
                },
                [_vm._v("Отправить\n      ")]
              ),
            ],
            1
          ),
        ])
      : _vm.request
      ? _c("div", [
          _c("p", { staticClass: "badge badge-info" }, [
            _c("strong", [
              _vm._v(
                _vm._s(
                  _vm.moment(_vm.request.report_date, "HH:mm:ss DD.MM.YYYY")
                )
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("\n      Сумма: "),
            _c("strong", [
              _vm._v(_vm._s(_vm.request.sum.toLocaleString("ru-RU"))),
            ]),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("\n      Старый конверт:\n      "),
            _c("strong", [
              _vm._v(_vm._s(_vm.request.cash_amount.toLocaleString("ru-RU"))),
            ]),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("\n      Заявки:\n      "),
            _c("strong", [
              _vm._v(_vm._s(_vm.request.adm_amount.toLocaleString("ru-RU"))),
            ]),
            _vm._v(" (сумма\n      к сдаче - АВТОинкассация)\n    "),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("\n      ЗП: "),
            _c("strong", [
              _vm._v(_vm._s(_vm.request.salary_amount.toLocaleString("ru-RU"))),
            ]),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("\n      Почтовые р.:\n      "),
            _c("strong", [
              _vm._v(_vm._s(_vm.request.post_amount.toLocaleString("ru-RU"))),
            ]),
          ]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("p", [
            _vm._v("\n      Калькуляция:\n      "),
            _c("strong", [
              _vm._v(
                _vm._s(_vm.request.sum) +
                  " + " +
                  _vm._s(Math.round(_vm.request.cash_amount * 10) / 10) +
                  " -\n        " +
                  _vm._s(_vm.request.adm_amount) +
                  " - " +
                  _vm._s(_vm.request.salary_amount) +
                  " -\n        " +
                  _vm._s(_vm.request.post_amount)
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("p", [
            _vm._v("\n      Новый конверт:\n      "),
            _c("strong", [
              _vm._v(
                _vm._s(
                  (
                    _vm.request.sum -
                    _vm.request.adm_amount -
                    _vm.request.salary_amount -
                    _vm.request.post_amount +
                    _vm.request.cash_amount
                  ).toLocaleString("ru-RU")
                )
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("\n      Снято: "),
            _c("strong", [
              _vm._v(_vm._s(_vm.request.sum.toLocaleString("ru-RU"))),
            ]),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("\n      Автоинкассация:\n      "),
            _c("strong", [
              _vm._v(_vm._s(_vm.request.adm_amount.toLocaleString("ru-RU"))),
            ]),
          ]),
          _vm._v(" "),
          _vm.cashOutData.incashment
            ? _c(
                "p",
                {
                  class: {
                    badge: true,
                    "badge-info": _vm.request.status === 1,
                    "badge-success": _vm.request.status === 2,
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.request.status === 2
                          ? "Подтверждено " +
                              _vm.moment(
                                _vm.cashOutData.incashment.created_at,
                                "HH:mm:ss DD.MM.YYYY"
                              )
                          : "На подтверждении"
                      ) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
        ])
      : _c("div", [_c("p", [_vm._v("Снятие недоступно в текущих условиях")])]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }